import { Menu } from '@/components/organisms/Menu/Menu'
import React from 'react'
import Image from 'next/image'
import about from '@/styles/frequent_questions/index.module.scss'
import { Footer } from '@/components/organisms/Footer/Footer'
import { FrequentQuestions } from '@/components/organisms/FrequentQuestions/FrequentQuestions'
import { frequentquestions } from '@/data/dummy/frequentquestions'

export default function index () {
  function chunk (arr, size) {
    return arr.reduce((result, item, index) => {
      const chunkIndex = Math.floor(index / size)
      if (!result[chunkIndex]) {
        result[chunkIndex] = []
      }
      result[chunkIndex].push(item)
      return result
    }, [])
  };
  const frequentquestionsGrups = chunk(frequentquestions, 1)
  return (
    <>
      <Menu />
      <div style={{ backgroundColor: '#ffffff' }}>
        <div className={about.body_section}>
          <div className={about.image_container}>
            <Image
              src='/img/contacto.png'
              className={about.logo1}
              alt='Picture of the author '
              width={500}
              height={500}
            />
          </div>
          <div className={about.title_container}>
            <h2 className={about.title1}>Preguntas frecuentes</h2>
            {
            frequentquestionsGrups.map((group, index) => (
              <div key={index} className={about.containerquestions}>
                {
                   group.map((frequentquestions, index) => (
                     <FrequentQuestions key={index} {...frequentquestions} />
                   ))
                }
              </div>

            ))
          }
          </div>
        </div>
      </div>
      <Footer />
    </>
  )
}
